import { User } from 'store/auth/auth.types'

export const getUserId = () => window.sessionStorage.getItem('userId') ?? ''

export const getAccessToken = () =>
  window.sessionStorage.getItem('accessToken') ?? ''

export const getRole = () =>
  window.sessionStorage.getItem('role') ?? ''

export const formatAddress = (companyData: User | undefined) => {
  const { streetNumber, streetName, city, zipCode } = companyData || {}

  const parts: string[] = []

  // Combine street number and street name
  const street = [streetNumber, streetName].filter(Boolean).join(' ').trim()
  if (street) {
    parts.push(street)
  }

  if (city) {
    parts.push(city)
  }

  if (zipCode) {
    parts.push(zipCode)
  }

  // Format: "2010 Winston Park Drive, Oakville, L6H 5R7"
  return parts.join(', ')
}

export const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

export const cleanString = (str: string) => {
  return str.replace(/[^a-zA-Z0-9]# /g, '').replace(/\s+/g, ' ')
}
